import { UserGroup } from './user-group'
/**
 * 需要隐藏的patch
 */
export const NEED_HIDE_IMAGE_NAMES = [
  'windows10_ltsc2021_x64_cn_cloud_patch2504'
]

export { UserGroup }
